var React = require('react');

function BubbleArrow1 (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-90.387 -156.46)"},React.createElement("path",{"d":"m90.462 176.51-0.07439 10.993 36.849-31.045z","fill":"#fff","strokeWidth":".26458","data-name":"Контур 335839"})));
}

BubbleArrow1.defaultProps = {"width":"36.849mm","height":"31.045mm","version":"1.1","viewBox":"0 0 36.849 31.045"};

module.exports = BubbleArrow1;

BubbleArrow1.default = BubbleArrow1;
